import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_APPOINTMENT_COMPLETE_STATUS,
    saveAppointmentCompleteStatusFail,
    saveAppointmentCompleteStatusSuccess
} from '../action/saveAppointmentCompleteStatusAction'

// api 
import saveAppointmentCompleteStatusApi from '../api/saveAppointmentCompleteStatusApi'

export function* saveAppointmentCompleteStatusSaga(action) {

    try {
        const response = yield call(() => saveAppointmentCompleteStatusApi(action.params))
        if (response.data.status === 1) {
            yield put(saveAppointmentCompleteStatusSuccess(response, action))
        } else {
            yield put(saveAppointmentCompleteStatusFail(response, action))
        }
    }
    catch (e) {
        yield put(saveAppointmentCompleteStatusFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_APPOINTMENT_COMPLETE_STATUS, saveAppointmentCompleteStatusSaga)
}